/**
 * Replaceable brand assets. No company logo is bundled: to add one, place the approved
 * file in `public/brand/` and set VITE_BRAND_LOGO_URL (e.g. "/brand/logo.svg").
 * Contact details come from the API (`/api/v1/meta/config`) so they are configured once.
 */
export const brand = {
  name: "Bill's Blueprint",
  portalName: "Bill's Blueprint Customer Portal",
  logoUrl: (import.meta.env.VITE_BRAND_LOGO_URL as string | undefined) || null,
  logoAlt: "Bill's Blueprint",
};
